import { buffers, eventChannel, END } from 'redux-saga'
import axios from 'CanExConfig/axios'

export const fetchProfile = async id => {
  const response = await axios(`/api/candidate/v2/candidate_profiles/${id}`, {
    method: 'GET',
  })
  return response.data.result
}

export const updateProfile = async (data, id) => {
  const response = await axios(`/api/candidate/v2/candidate_profiles/${id}`, {
    method: 'PATCH',
    data,
  })

  return response.data.result
}

export const fetchProfileImage = async id => {
  const response = await axios.get(`/api/candidate/profiles/${id}/profile_image`, {
    method: 'GET',
  })

  return response.data.result
}

const uploadProfileImage = async (id, data, emitter) => {
  const formData = new FormData()
  formData.append('file', data)

  const response = await axios(`/api/candidate/profiles/${id}/profile_image`, {
    method: 'POST',
    data: formData,
    onUploadProgress: progressEvent => emitter({ progressEvent }),
  })

  emitter({ response: response.data })
  emitter(END)
}

export const uploadFileChannel = (id, data) =>
  eventChannel(emitter => {
    uploadProfileImage(id, data, emitter)
    return () => {}
  }, buffers.sliding(2))
